import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  opened: false
}

const SetAgeGroupDialogReducer = createReducer(defaultState, {
  'GROUPS:ADD_GROUP_DIALOG:OPEN': (state, { ids }) => ({
    ...state,
    opened: true
  }),
  'GROUPS:ADD_GROUP_DIALOG:CLOSE': state => ({ ...state, opened: false }),
  'GROUPS_STORE:CREATE_REQUEST_SUCCESS': state => ({ ...state, opened: false })
})

export default SetAgeGroupDialogReducer
